var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9132 20.0205C22.5818 19.8221 22.1508 19.6009 21.7602 19.7607C21.4609 19.8831 21.2698 20.3518 21.0755 20.5914C20.9758 20.7142 20.8572 20.7334 20.7041 20.672C19.58 20.2242 18.7186 19.4736 18.0981 18.4396C17.9931 18.2788 18.012 18.1522 18.1386 18.0032C18.3262 17.7825 18.5613 17.5321 18.6122 17.2346C18.6628 16.9371 18.5233 16.5897 18.4005 16.325C18.2436 15.9867 18.0678 15.504 17.7291 15.3125C17.4177 15.1367 17.0072 15.2351 16.7296 15.4611C16.2507 15.8514 16.0195 16.4624 16.0265 17.0686C16.0282 17.2408 16.0495 17.4124 16.0899 17.5788C16.1865 17.9785 16.371 18.3517 16.5792 18.7064C16.7358 18.9739 16.9064 19.2333 17.0898 19.4831C17.6911 20.2999 18.4392 21.0096 19.3052 21.5401C19.738 21.8051 20.2043 22.0378 20.687 22.1971C21.2283 22.3761 21.7106 22.5623 22.2955 22.451C22.9076 22.3349 23.511 21.9561 23.7537 21.3664C23.8255 21.1917 23.8615 20.9974 23.8214 20.8129C23.738 20.4317 23.2218 20.2047 22.9132 20.0205Z",
    fill: "url(#paint0_linear_9_2726)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9186 10.8505C15.4796 10.8505 11.8681 14.4619 11.8681 18.9006C11.8681 20.2584 12.2165 21.5962 12.8781 22.7897L11.7094 27.1496L16.092 25.9757C17.2701 26.6146 18.586 26.9512 19.919 26.9512C24.3577 26.9512 27.9692 23.3397 27.9692 18.9006C27.9688 14.4619 24.3574 10.8505 19.9186 10.8505ZM19.9186 25.4295C18.7513 25.4295 17.599 25.1104 16.5855 24.5063L16.3093 24.3417L13.8613 24.9977L14.5135 22.5634L14.344 22.2854C13.7193 21.2597 13.3894 20.0892 13.3894 18.9006C13.3894 15.3007 16.3183 12.3721 19.9183 12.3721C23.5179 12.3721 26.4468 15.3007 26.4468 18.9006C26.4472 22.5009 23.5182 25.4295 19.9186 25.4295Z",
    fill: "url(#paint1_linear_9_2726)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8392 0C9.34595 0 0.839233 8.50672 0.839233 19C0.839233 29.4936 9.34595 38 19.8392 38C30.3329 38 38.8392 29.4933 38.8392 19C38.8392 8.50672 30.3325 0 19.8392 0ZM19.8392 35.3958C10.7986 35.3958 3.4438 28.0407 3.4438 19.0003C3.4438 9.96002 10.7989 2.60492 19.8392 2.60492C28.8799 2.60492 36.2346 9.96002 36.2346 19.0003C36.2346 28.0407 28.8799 35.3958 19.8392 35.3958Z",
    fill: "url(#paint2_linear_9_2726)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2726",
    x1: 5.98036,
    y1: 6.04798,
    x2: 33.649,
    y2: 33.0191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_2726",
    x1: 5.09408,
    y1: 6.95724,
    x2: 32.7627,
    y2: 33.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_2726",
    x1: 6.23371,
    y1: 5.73767,
    x2: 33.9024,
    y2: 32.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappicon);
export default __webpack_public_path__ + "static/media/whatsappicon.9454a8921bcb78805f6103bc292265d3.svg";
export { ForwardRef as ReactComponent };